import { IBreakpoints, IBreakpointsWidth } from '../interfaces/IBreakpoints';

const getPercentByColumnNumber = (columns: number): string => {
    return `${100 / columns}%`;
};

export const getColumnsWidth = (breakpoints: IBreakpoints): IBreakpointsWidth => {
    const {
        numColumnsMobile,
        numColumnsDesktop,
        numColumnsLargeScreen,
        numColumnsExtraLargeScreen
    } = breakpoints;

    return {
        columnWidthMobile: getPercentByColumnNumber(numColumnsMobile),
        columnWidthDesktop: getPercentByColumnNumber(numColumnsDesktop),
        columnWidthLargeScreen: getPercentByColumnNumber(numColumnsLargeScreen),
        columnWidthExtraLargeScreen: getPercentByColumnNumber(numColumnsExtraLargeScreen)
    };
};
